import React, { useEffect, useState } from 'react'
import { Grid, TableCell, TableHead, TableBody, TableRow, Table, TableSortLabel, TablePagination, Paper, Tooltip } from '@material-ui/core';
import DownloadXLSAssetDetail from '../../../shared_elements/DownloadXLSAssetDetail';
import InfoIcon from '@material-ui/icons/Info';
import { globalExportService, globalGetService } from '../../../utils/globalApiServices';
import { downloadFileType, checkApiStatus, Comma_format } from '../../../utils';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { PageLoader, EmptyCollection } from "../../../shared_elements";
import { Link } from "react-router-dom";
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
import { backendDateFormat, dayMonthDateFormat } from '../../../constants';
import FilterComponent from '../../../shared_elements/components/filter_component';
import { dashboardFilterOptions } from '../index';
import ReportsTab from '../../fleet/components/ReportsTab';
import { trackActivity } from '../../../utils/mixpanel';
import { smbcInstance } from '../../../shared_elements/components';
import { ExportMenu } from '../../../shared_elements';
function SmbcDashboardList() {
    const { enqueueSnackbar } = useSnackbar();
    const [dashboardList, setDashboardList] = useState();
    const [pageLoader, setPageLoader] = useState(false);
    const [skeltonLoader, setSkeltonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filterEngineTypes, setFilterEngineTypes] = useState([]);
    const [filterLessee, setFilterLessee] = useState([]);
    const [filter, setFilter] = useState({});
    const [date, setDate] = useState({ last_twelve_month_date: null, from_date: null, to_date: null });

    useEffect(() => {
        smbcDashboard({ per_page: 250 });
        getLessee();
        getEngineTypes();
        trackActivity('Portfolio Page Visited - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'SMBC Summary',
        });
    }, []);

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' };
        }
        setSortInfo(sortQuery);
        smbcDashboard({ ...sortQuery, ...date, page: 1, per_page: 250 }, 'pageLoader');
    };

    const smbcDashboardExport = (extension) => {
        setPageLoader(true);
        const queryParams = sortInfo?.sort === '' && sortInfo?.sort_by === ''
            ? Object.assign({}, filter)
            : Object.assign({}, filter, sortInfo);
        globalExportService(`/camo/smbc_summary/?download=${extension}`, { ...queryParams, ...date })
            .then((response) => {
                setPageLoader(false);
                if (checkApiStatus(response)) {
                    downloadFileType(response?.data, `Portfolio_Report_${moment().format(dayMonthDateFormat)}`, 'xlsx');
                    enqueueSnackbar("SMBC Summary Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                    trackActivity('Portfolio Exported Success - Airworthiness Management', {
                        event_type: 'Exported Success',
                        page_title: 'SMBC Summary',
                        file_extension: 'xlsx',
                        sucess_msg: 'SMBC Summary Download Successfully.',
                    });
                } else {
                    enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                    trackActivity('Portfolio Exported Failed - Airworthiness Management', {
                        event_type: 'Exported Failed',
                        page_title: 'SMBC Summary',
                        file_extension: 'xlsx',
                        error_msg: 'Something went wrong.',
                    });
                }
            });
    };

    const smbcDashboard = (query, loader) => {
        loader === "pageLoader" ? setPageLoader(true) : setSkeltonLoader(true);
        globalGetService(smbcInstance ? `/camo/smbc_summary/` : `/camo/summary/`, { ...query })
            .then((response) => {
                loader === "pageLoader" ? setPageLoader(false) : setSkeltonLoader(false);
                setDashboardList(response.data?.data);
                setFilter(query, delete query.per_page, delete query?.last_twelve_month_date, delete query?.to_date);
            });
    };

    const onFieldChange = (keyParam, value) => {
        let newDateState = {};
        const queryParams = { per_page: 250 };

        if (keyParam === "last_twelve_month_date") {
            newDateState = { [keyParam]: value };
        } else {
            newDateState = { last_twelve_month_date: date?.last_twelve_month_date, [keyParam]: value };
        }
        if (date?.last_twelve_month_date) {
            queryParams.last_twelve_month_date = date.last_twelve_month_date;
        }
        if (date?.from_date) {
            queryParams.from_date = date.from_date;
        }
        queryParams[keyParam] = value;
        setDate(prev => ({ ...prev, ...newDateState }));
        smbcDashboard(queryParams, 'pageLoader');
    };

    const getEngineTypes = () => {
        globalGetService(`console/engine-types/`, { distinct: 1 })
            .then(response => {
                if (checkApiStatus(response)) {
                    setFilterEngineTypes(response.data.data.engineTypes);
                }
            });
    };

    const getLessee = () => {
        globalGetService(`console/lessees/?distinct=1`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setFilterLessee(response.data.data.lessees);
                }
            });
    };

    const filterObj = Object.assign({}, filter, delete filter?.page,filter?.per_page,delete filter?.from_date,delete filter?.sort, delete filter?.sort_by);
    let filterOptions = Object.assign({}, dashboardFilterOptions);
    filterOptions = {
        ...filterOptions,
        engine_type: { ...filterOptions.engine_type, options: filterEngineTypes },
        lessee: { ...filterOptions.lessee, options: filterLessee },
    };

    const tableSorting = (key, name) => (
        <TableSortLabel
            active={sortInfo.sort === key}
            direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
            onClick={() => createSortHandler(key)}
        >
            {name}
        </TableSortLabel>
    );

    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;

    return (
        <section className="camo-dashboard">
            <ReportsTab tabIndex="portfolio" />
            {skeltonLoader ? <STabsLoader count={tabsLoaderCount} /> :
                <Paper square className="smbc-filter-paper">
                    <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center' }}>
                        <Grid item md={9} sm={10} xs={8}>
                            <div className="smbc-filter-container">
                                <FilterComponent
                                    filter={filterObj}
                                    filterMenu={filterOptions}
                                    getResponseBack={(applyFilter) => smbcDashboard({ ...date, ...applyFilter, page: 1, per_page: dashboardList?.pagination?.per_page }, 'pageLoader')}
                                />
                            </div>
                        </Grid>
                        <Grid item md={3} sm={2} xs={4}>
                            <ul className="list-inline smbc-export-container">
                                <li className="list-inline-item smbc-export-item">
                                    <ExportMenu
                                        exportReportFn={(file) => smbcDashboardExport(file.extension)}
                                        files={[{ title: 'EXCEL', extension: 'xlsx' }]}
                                        title='EXPORT'
                                    />
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>}
            {skeltonLoader ? <STableLoader count={tabsLoaderCount} size={9} /> :
                <Paper square className="smbc-table-paper">
                    <h4 className="smbc-portfolio-title">Portfolio</h4>
                    <div className="smbc-dasboard-list" style={{ height: (window.innerHeight - 270) + 'px' }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={16} style={{ textAlign: 'left' }}>
                                       Total Engine :- {dashboardList?.pagination?.total}
                                    </TableCell>
                                    <TableCell colSpan={4}>Installed</TableCell>
                                    <TableCell colSpan={1}>Update</TableCell>
                                    <TableCell colSpan={7}>Current Condition</TableCell>
                                    <TableCell colSpan={4}>Average Utilization FC Per Months</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="min-width-200">{tableSorting('owner', 'Asset Owner')}</TableCell>
                                    <TableCell>{tableSorting('lessee', 'Lessee')}</TableCell>
                                    <TableCell>{tableSorting('operator', 'Operator')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('on_lease', 'On Lease Y/N')}</TableCell>
                                    <TableCell>{tableSorting('country', 'Country')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('eng_type', 'Engine Type')}</TableCell>
                                    <TableCell>{tableSorting('esn', 'ESN')}</TableCell>
                                    <TableCell className="min-width-150">{tableSorting('qec', 'QEC Config')}</TableCell>
                                    <TableCell>{tableSorting('manufacturing_date', 'DOM')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('qec_part_number', 'QEC Part No')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('bag', 'Stand & Bag')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('software_part_number', 'EEC Software P/N')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('software_version', 'EEC Software Version')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('lease_start_date', 'Lease Start Date')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('lease_term_date', 'Lease Expiry Date')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('month_remaining', 'Months Remaining')}</TableCell>
                                    <TableCell>{tableSorting('tail', 'Tail')}</TableCell>
                                    <TableCell>{tableSorting('psn', 'PSN')}</TableCell>
                                    <TableCell>{tableSorting('thrust', 'Thrust')}</TableCell>
                                    <TableCell>{tableSorting('date', 'Date')}</TableCell>
                                    <TableCell>
                                        {tableSorting('update_date', 'Update')}
                                        <Tooltip title="Update (Utilization As of Date)" placement="top" arrow>
                                            <InfoIcon size="small" className="smbc-info-icon" />
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>{tableSorting('current_codition_tsn', 'TSN')}</TableCell>
                                    <TableCell>{tableSorting('current_codition_csn', 'CSN')}</TableCell>
                                    <TableCell>{tableSorting('current_codition_tsr', smbcInstance ? 'TSPR' : 'TSLSV')}</TableCell>
                                    <TableCell>{tableSorting('current_codition_csr', smbcInstance ? 'CSPR' : 'CSLSV')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('current_codition_limiter', 'LLP Limiter(s)')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('min_llp_date', 'SV Forecast Date')}</TableCell>
                                    <TableCell className="min-width-200">{tableSorting('hpt_blade_limit', 'Soft-time Limiter(s)')}</TableCell>
                                    <TableCell className="last-tweleve-month">
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                label="Past 12 Months"
                                                format={dayMonthDateFormat}
                                                disableFuture
                                                style={{ width: "180px" }}
                                                value={date?.last_twelve_month_date || null}
                                                InputLabelProps={{ shrink: true }}
                                                error={false}
                                                helperText=""
                                                clearable
                                                onChange={(data) => onFieldChange('last_twelve_month_date', moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
                                                inputVariant="outlined"
                                            />
                                        </MuiPickersUtilsProvider>
                                    </TableCell>
                                    <TableCell className="average-utils-date">
                                        <ul className="list-inline">
                                            <li className="list-inline-item">
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        label="From Date"
                                                        format={dayMonthDateFormat}
                                                        disableFuture
                                                        disabled={!date?.last_twelve_month_date}
                                                        minDate={moment(date?.last_twelve_month_date).add(1, 'days')}
                                                        style={{ width: "180px" }}
                                                        value={date?.from_date || null}
                                                        InputLabelProps={{ shrink: true }}
                                                        error={false}
                                                        helperText=""
                                                        onChange={(data) => onFieldChange('from_date', moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
                                                        inputVariant="outlined"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </li>
                                            <li className="list-inline-item smbc-date-item">
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        label="To Date"
                                                        format={dayMonthDateFormat}
                                                        disableFuture
                                                        disabled={!date?.last_twelve_month_date}
                                                        minDate={moment(date?.from_date)}
                                                        style={{ width: "180px" }}
                                                        value={date?.to_date || null}
                                                        InputLabelProps={{ shrink: true }}
                                                        error={false}
                                                        helperText=""
                                                        onChange={(data) => onFieldChange('to_date', moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
                                                        inputVariant="outlined"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </li>
                                        </ul>
                                    </TableCell>
                                    <TableCell>{tableSorting('delta_ratio', 'Delta Ratio')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dashboardList?.asset?.map((item, index) => (
                                    <TableRow key={index} component={Link} to={`/${item.asset_id}/2/op_history/list`}>
                                        <TableCell>{item.owner || '--'}</TableCell>
                                        <TableCell>{item.lessee || '--'}</TableCell>
                                        <TableCell>{item.operator || '--'}</TableCell>
                                        <TableCell>{item.on_lease || '--'}</TableCell>
                                        <TableCell>{item.country || '--'}</TableCell>
                                        <TableCell>{item.eng_type || '--'}</TableCell>
                                        <TableCell>{item.esn || '--'}</TableCell>
                                        <TableCell>{item.qec || '--'}</TableCell>
                                        <TableCell>{item.manufacturing_date ? moment(item.manufacturing_date).format(dayMonthDateFormat) : "--"}</TableCell>
                                        <TableCell>{item.qec_part_number || '--'}</TableCell>
                                        <TableCell>{item.stand}-{item.bag}</TableCell>
                                        <TableCell>{item.software_part_number || '--'}</TableCell>
                                        <TableCell>{item.software_version || '--'}</TableCell>
                                        <TableCell>{item.lease_start_date ? moment(item.lease_start_date).format(dayMonthDateFormat) : "--"}</TableCell>
                                        <TableCell>{item.lease_term_date ? moment(item.lease_term_date).format(dayMonthDateFormat) : "--"}</TableCell>
                                        <TableCell>{item?.month_remaining === null ? '--' : item.month_remaining >=0 ? item.month_remaining :  item.month_remaining < 0 && '0' }</TableCell>
                                        <TableCell>{item.tail || '--'}</TableCell>
                                        <TableCell>{item.psn || '--'}</TableCell>
                                        <TableCell>{item.thrust || '--'}</TableCell>
                                        <TableCell>{item.date || '--'}</TableCell>
                                        <TableCell>{item.update_date ? moment(item.update_date).format(dayMonthDateFormat) : "--"}</TableCell>
                                        <TableCell>{item.current_codition_tsn ? Comma_format(item.current_codition_tsn.toFixed(2)) : '0'}</TableCell>
                                        <TableCell>{item.current_codition_csn ? Comma_format(parseInt(item.current_codition_csn)) : '0'}</TableCell>
                                        <TableCell>{item.current_codition_tsr ? Comma_format(item.current_codition_tsr.toFixed(2)) : '0'}</TableCell>
                                        <TableCell>{item.current_codition_csr ? Comma_format(parseInt(item.current_codition_csr)) : '0'}</TableCell>
                                        <TableCell>{item.current_codition_limiter ? Comma_format(parseInt(item.current_codition_limiter)) : item.current_codition_limiter === null ? 'N/A' : '0'}</TableCell>
                                        <TableCell>{moment(item.min_llp_date).isValid() ? moment(item.min_llp_date).format(dayMonthDateFormat) : item.min_llp_date || 'N/A'}</TableCell>
                                        <TableCell>{item.hpt_blade_limit > 0 ? Comma_format(item.hpt_blade_limit) : item.hpt_blade_limit === null ? 'N/A' : '0'}</TableCell>
                                        <TableCell>{item?.util_last_twelve_month || '--'}</TableCell>
                                        <TableCell>{item?.util_from_date || "--"}</TableCell>
                                        <TableCell>{item.delta_ratio || '--'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {!dashboardList?.asset && <EmptyCollection description="No records found" />}
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[100, 150, 200, 250]}
                        component="div"
                        count={dashboardList?.pagination?.total}
                        rowsPerPage={parseInt(dashboardList?.pagination?.per_page)}
                        page={dashboardList?.pagination?.page - 1}
                        backIconButtonProps={{ "aria-label": "previous page" }}
                        nextIconButtonProps={{ "aria-label": "next page" }}
                        onChangePage={(event, newPage) => smbcDashboard({ per_page: dashboardList.pagination.per_page, page: newPage + 1, last_twelve_month_date: date?.last_twelve_month_date || null }, 'pageLoader')}
                        onChangeRowsPerPage={(event) => smbcDashboard({ per_page: event.target.value, last_twelve_month_date: date?.last_twelve_month_date || null }, "pageLoader")}
                    />
                </Paper>}
            {pageLoader && <PageLoader />}
        </section>
    );
}

export default SmbcDashboardList;
